import Vue from 'vue';
import extend from 'extend';
import Http from '../libs/http';
import { regInvalids } from '../regs/application-regs';
import { envPrefix } from '../libs/env';
// import { dateReg } from '../regs/application-regs';

// 申请表字段信息缓存
const applicantionFieldsStore = {};

export default {

  /**
   * 根据后端返回的手机版的申请表链接提取出国家字段,并拼接出真正的请求配置链接
   * @param {String} backendApplicationUrl 后端返回的申请表链接
   * @return {String}
   */
  getApplicationCountryName(backendApplicationUrl) {
    let result = '';
    if (backendApplicationUrl) {
      const countryParamsStrIndex = backendApplicationUrl.indexOf('country');
      if (countryParamsStrIndex > -1) {
        const countryName = backendApplicationUrl.substring(countryParamsStrIndex + 8, backendApplicationUrl.length);
        if (countryName) {
          result = countryName;
        }
      }
    }
    return result;
  },


  /**
   * 获取申请表配置
   * @param {String} applicationConfigUrl 申请表配置链接
   * @return {Promise}
   */
  getApplicationConfig(backendApplicationUrl) {
    return new Promise((resolve, reject) => {
      window._applicationConfig = undefined;
      const country = this.getApplicationCountryName(backendApplicationUrl);
      if (!country) return reject('请求数据失败');
      Vue.http.get(`https://${envPrefix}mweb.666visa.cn/application-h5/dist/static/apply_data/${country}.js?v=${Math.random()}`).then((res) => {
        try {
          const jsContent = res.body;
          // eslint-disable-next-line no-eval
          eval(jsContent);
          if (!window._applicationConfig) return Promise.reject('请求数据失败');
          resolve(window._applicationConfig);
          return window._applicationConfig;
        } catch (err) {
          return Promise.reject('请求数据失败');
        }
      }).catch(() => {
        Vue.http.get(`https://${envPrefix}mweb.666visa.cn/application-h5/dist/static/apply_data/${country}.json?v=${Math.random()}`).then((data) => {
          if (data.body) {
            resolve(data.body);
            return data.body;
          }
          reject('请求数据失败');
        }).catch((e) => {
          reject(e);
        });
      });
    });

  },

  // 获取申请表配置数据，这个方法是有缓存的，暂时仅在申请人计算上传资料百分比使用
  getApplicationFields(backendApplicationUrl) {
    const country = this.getApplicationCountryName(backendApplicationUrl);
    if (applicantionFieldsStore[country]) {
      // 已经请求过了，直接返回
      if (applicantionFieldsStore[country].fields) {
        return Promise.resolve(applicantionFieldsStore[country].fields);
      } else if (applicantionFieldsStore[country].promise) {
        return Promise.resolve(applicantionFieldsStore[country].promise);
      }
    } else {
      applicantionFieldsStore[country] = {};
    }
    return new Promise((resolve, reject) => {
      applicantionFieldsStore[country].promise = this.getApplicationConfig(backendApplicationUrl).then((data) => {
        applicantionFieldsStore[country].fields = data;
        resolve(data);
      }).catch((e) => {
        reject(e);
      });
    });
  },

  /**
   * 获取申请人的申请表数据
   * @param {Number} applicantId 申请人编号
   * @return {Promise}
   */
  getApplicationData(applicantId) {
    return Http.mPost('/application/applicant_application_query', {
      order_applicant_id: applicantId,
    });
  },

  /**
   * 申请表数据保存
   * @param {Number} applicantId 申请人编号
   * @param {Object} applicationData 申请表数据
   * @param {String} groupName 组名
   * @return {Promise}
   */
  applicationSave(applicantId, applicationData, groupName, embassy_district = {}) {
    return Http.mPost('/application/applicant_application_save', {
      order_applicant_id: +applicantId,
      content: JSON.stringify(extend(true, {}, applicationData, (groupName ? { [groupName]: true } : {}))),
      ...embassy_district,
    });
  },

  /**
  * 申请表数据提交（考虑还是不用同一个方法使用不同参数了）
  * @param {Number} applicantId 申请人编号
  * @param {Object} applicationData 申请表数据
  * @return {Promise}
  */
  applicationSubmit(applicantId, applicationData, embassy_district = {}) {
    return Http.mPost('/application/applicant_application_submit', {
      order_applicant_id: +applicantId,
      content: JSON.stringify(applicationData),
      ...embassy_district,
    });
  },

  /**
   * 创建申请表提交数据
   * @param {Object} applicationData 申请表数据
   * @param {Array} groupStatus 组状态
   * @return {Object}
   */
  createApplicationSubmitData(applicationData, groupStatus) {

    // 这几个参数都是application-h5那边写的,要跟那边保持一致
    return extend(true, {}, applicationData, {
      saved: 1,
      ensured: 1,
      SubmitPlatform: 'www/peer', // 表示是同业在修改
      apply_time: new Date().format('yyyy/MM/dd'),
    }, groupStatus);
  },

  /**
   * 设置需要大写的字段
   * @param {Object} applicationData 申请表数据
   * @param {Array} applicationConfig 申请表配置
   * @return {Object}
   */
  setAllNeedUpperCaseField(applicationData, applicationConfig) {
    const result = extend(true, {}, applicationData);
    if (applicationConfig && applicationData) {
      applicationConfig.forEach((configGroup) => {

        // 遍历每个配置组
        configGroup.fields.forEach((field) => {

          // 弹出需要往里面处理一层
          if (field.type === 'Popup') {
            field.popupFields.forEach((popupField) => {
              if (popupField.tran2up) {
                if (applicationData[field.popupName] && applicationData[field.popupName].length > 0 && Object.keys(applicationData[field.popupName][0]).length > 0) {
                  applicationData[field.popupName].forEach((item, index) => {
                    const value = item[popupField.name];
                    if (value) {
                      result[field.popupName][index][popupField.name] = value.toUpperCase().trim();
                    }
                  });
                  // const value = applicationData[field.popupName][popupField.name];
                  // if (value) {
                  //   result[field.popupName][popupField.name] = value.toUpperCase().trim();
                  // }
                }
              }
            });
          } else {
            if (field.tran2up) {
              const value = applicationData[field.name];
              if (value) {
                result[field.name] = value.toUpperCase().trim();
              }
            }
          }
        });
      });
    }
    return result;
  },

  /**
   * 根据申请表配置的value字段来设置申请表数据的默认值
   * @param {Array} applicationConfig 申请表配置
   * @return {Object}
   */
  setDefaultValueByApplicationConfig(applicationConfig) {
    const result = {};
    if (applicationConfig) {
      applicationConfig.forEach((configGroup) => {

        // 遍历每个配置组
        configGroup.fields.forEach((field) => {

          // 弹出需要往里面处理一层
          if (field.type === 'Popup') {

            // 如果遇到默认值的时候还没有数组,就设置上
            if (!result[field.popupName]) {
              result[field.popupName] = [];
              // 如果设置了默认的卡片数量，则把卡片增加到默认值
              if (field.popupDefault !== undefined) {
                for (let i = 0; i < field.popupDefault; i++) {
                  result[field.popupName].push({});
                }
              } else {
                result[field.popupName].push({});
              }
            }
            result[field.popupName].forEach((popup) => {
              field.popupFields.forEach((popupField) => {

                // 弹出层字段有默认值
                if (popupField.value) {
                  popup[popupField.name] = popupField.value;
                }
              });
            });

          } else {
            if (field.value) {
              result[field.name] = field.value;
            }
          }
        });
      });
    }
    return result;
  },


  /**
   * 将区域字符串转为code数组
   *
   * @param {String} pcdNameString 区域字符串
   * @returns {Array}
   */
  pcdNamesToCode(pcdNameString, transformedPcds) {
    if (!pcdNameString || typeof (pcdNameString) !== 'string') return [];

    const pcdNameArr = pcdNameString.split(' ');
    let province = 0;
    let city = 0;
    let district = 0;

    if (!transformedPcds[86]) return [];

    if (pcdNameArr[0]) {
      transformedPcds[86].forEach((p) => {
        if (p.label === pcdNameArr[0] || pcdNameArr[0] === p.label) {
          province = p.value;
        }
      });
    }

    if (pcdNameArr[1] && province && transformedPcds[province]) {
      transformedPcds[province].forEach((c) => {
        if (c.label === pcdNameArr[1] || pcdNameArr[1] === c.label) {
          city = c.value;
        }
      });
    }

    if (pcdNameArr[2] && city && transformedPcds[city]) {
      transformedPcds[city].forEach((d) => {
        if (d.label === pcdNameArr[2] || pcdNameArr[2] === d.label) {
          district = d.value;
        }
      });
    }

    return [province, city, district];
  },


  // 转化省市区数据
  tranformPcd(pcds) {
    const result = {};
    Object.keys(pcds).forEach((key) => {
      result[key] = Object.keys(pcds[key]).map(code => ({
        value: code,
        label: pcds[key][code],
      }));
    });
    return result;
  },

  /**
   * 判断字段是否显示（已检查）
   *
   * @param {Object} applicationData 申请表数据对象
   * @param {Object} fieldConfig 字段的配置，来源于申请表配置
   * @param {Object} popupItemData 弹出组的一项的数组
   * @returns {Boolean}
   */
  showField(fieldConfig, applicationData, popupItemData) {

    // “当啥时候显示” 这条配置没有或者配置未空数组
    if (!fieldConfig.showWhile || (fieldConfig.showWhile && !fieldConfig.showWhile.length)) {
      return true;
    }

    // 每项都满足
    return fieldConfig.showWhile.every((when) => {
      // 函数形式的直接调用
      if (typeof when.condition === 'function') {
        try {
          return when.condition(applicationData, popupItemData);
        } catch (error) {
          return false;
        }
      }
      // const values = when.value != undefined ? when.value.split(',') : [''];
      let values = [];
      if (typeof when.value === 'boolean') {
        values = [when.value];
      }
      if (typeof when.value === 'string') {
        values = when.value.split(',');
      }
      if (typeof when.value === 'undefined') {
        values = [''];
      }

      // 如果传递了popupItemData，说明是弹出组的字段，但是如果弹出组中没有这个字段，那么就去全局找
      const whenValue = popupItemData && popupItemData[when.key] !== undefined ? popupItemData[when.key] : applicationData[when.key];

      return values.some((v) => {
        if (!when.condition || when.condition === '=') {
          return whenValue === v;
        } else if (when.condition === '<') {
          return whenValue < v;
        } else if (when.condition === '>') {
          return whenValue > v;
        }
        return whenValue !== undefined && whenValue !== '' && whenValue !== v;
      });
    });
  },

  /**
   * 对整个表单进行校验
   *
   * @param {Array} applicationConfig 所有字段配置
   * @param {Object} applicationData 申请表数据
   * @returns {Boolean}
   */
  formValid(applicationConfig, applicationData) {
    return applicationConfig.every(group => this.groupValid(group, applicationData));
  },

  /**
   * 表单组校验
   *
   * @param {Object} configGroup 申请表配置组
   * @param {Object} applicationData 申请表数据
   * @returns {Boolean}
   */
  groupValid(configGroup, applicationData) {
    if (!this.showField(configGroup, applicationData)) {
      return true;
    }
    return configGroup.fields.every((fieldConfig) => {
      if (fieldConfig.type === 'Popup') {

        // 不显示的都为true，这里是针对popup组是否显示的验证，所以不需要传递第三个参数
        if (!this.showField(fieldConfig, applicationData)) {
          return true;
        }

        return applicationData[fieldConfig.popupName] && applicationData[fieldConfig.popupName].every(
          popupData => fieldConfig.popupFields.every(field => this.fieldValid(applicationData, field, popupData)));
      }
      return this.fieldValid(applicationData, fieldConfig);
    });
  },

  /**
   * 单个字段校验
   *
   * @param {Object} applicationData 申请表数据
   * @param {Object} fieldConfig 字段配置
   * @param {Object} popupItemData 弹出组的一项的数据
   * @returns {Boolean}
   */
  fieldValid(applicationData, fieldConfig, popupItemData) {

    // 这里在验证的时候，如果传递了popupItemData，说明是弹出组中的字段，所以要用弹出组数据，而不是全局数据
    const dataOrigin = popupItemData || applicationData;
    // 当前条件下不显示或者隐藏的都是true
    if (!this.showField(fieldConfig, applicationData, popupItemData) || fieldConfig.hidden) {
      return true;
    }
    // 对于整个Popup而言是true, 但是对于子字段不是
    if (fieldConfig.type === 'Popup' || fieldConfig.type === 'TitleBox' || fieldConfig.type === 'TipsBox') {
      return true;
    }

    // 多选框必填校验
    if (fieldConfig.type === 'SelectBox' && fieldConfig.multiple && fieldConfig.require && (!dataOrigin[fieldConfig.name] || dataOrigin[fieldConfig.name].length === 0)) {
      return false;
    }

    // 非必填也是true
    if (!fieldConfig.require && (dataOrigin[fieldConfig.name] === '' || dataOrigin[fieldConfig.name] === undefined)) {
      return true;
    }

    // 如果是日期类型的，因为pc组件的特殊原因，要保持选中的fieldModel和实际看到的值相同
    // if (fieldConfig.type === 'DateBox') {
    //   const dateBoxValue = document.querySelector(`#${`${fieldConfig.name}-${fieldConfig.type}`} input`).value;
    //   // console.log(dateBoxValue);
    //   // if () {

    //   // }
    //   if (!dateReg.test(dateBoxValue)) {
    //     return false;
    //   }
    // }

    // 非法字符验证
    if (regInvalids.test(dataOrigin[fieldConfig.name])) {
      return false;
    }
    // 必填验证
    if (dataOrigin[fieldConfig.name] === undefined ||
        dataOrigin[fieldConfig.name] === '' ||
        (dataOrigin[fieldConfig.name] && typeof dataOrigin[fieldConfig.name] === 'string' && dataOrigin[fieldConfig.name].trim() === '')) {
      return false;
    }

    // 配置的正则
    if (fieldConfig.pattern) {
      if (typeof fieldConfig.pattern === 'function') {
        // 函数
        try {
          const errorMsg = fieldConfig.pattern(dataOrigin[fieldConfig.name], {
            dataModel: applicationData,
            application_content: applicationData,
            popup_item: popupItemData,
          });
          if (errorMsg) return false;
        } catch (error) {
          //
        }
      } else {
        // 正则
        const reg = new RegExp(fieldConfig.pattern);
        if (!reg.test(dataOrigin[fieldConfig.name])) {
          return false;
        }
      }
    }

    // 最大长度
    if (fieldConfig.maxLength && dataOrigin[fieldConfig.name].length > fieldConfig.maxLength) {
      return false;
    }

    // 最大值
    if (fieldConfig.numberMax && dataOrigin[fieldConfig.name] > fieldConfig.numberMax) {
      return false;
    }

    // 最小值
    if (fieldConfig.numberMin && dataOrigin[fieldConfig.name] < fieldConfig.numberMin) {
      return false;
    }

    return true;
  },


  /**
   * 过滤整个表单所有不符合规则的数据，并返回合规则数据
   *
   * @param {Array} applicationConfig 所有字段配置
   * @param {Object} dataModel 申请表数据
   * @returns {Object}
   */
  formFilter(applicationConfig, applicationData) {
    applicationConfig.forEach((group) => {
      applicationData = this.groupFilter(group, applicationData);
    });
    return applicationData;
  },

  /**
   * 过滤一个表单组校不合规则的数据，并返回合规则数据
   *
   * @param {Object} groupConfig 申请表配置组
   * @param {Object} applicationData 申请表数据
   * @returns {Object}
   */
  groupFilter(groupConfig, applicationData) {
    groupConfig.fields.forEach((field) => {
      if (field.type === 'Popup') {
        // 不显示的都为true
        if (!this.showField(applicationData, field)) {
          return;
        }

        if (!applicationData[field.popupName]) {
          return;
        }

        applicationData[field.popupName].forEach((pd) => {
          field.popupFields.forEach((field) => {
            if (!this.fieldValid(pd, field)) {
              pd[field.name] = '';
            }
          });
        });
      } else if (!this.fieldValid(applicationData, field)) {
        applicationData[field.name] = '';
      }
    });
    return applicationData;
  },
};



// WEBPACK FOOTER //
// ./src/services/application-form-service.js